import { z } from "zod";
import { CompanySchema } from "./Company";
import { PlaceSchema } from "./Place";

export const AccountUserFieldsSchema = z.object({
  id: z.number(),
  username: z.string(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  avatar: z.string(),
  verified: z.boolean(),
  sessionId: z.string(),
  lastAction: z.string(),
  loggedIn: z.boolean(),
  messageOnEmail: z.string(),
  phoneNumber: z.string(),
  mobileNumber: z.string(),
  defaultCurrency: z.string(),
  availableCurrencies: z.string(),
  importId: z.string(),
  importTyp: z.string(),
  isInvoiceUser: z.boolean(),
  language: z.string(),
  lastLoginDate: z.string(),
  lastLogoutDate: z.string(),
  failedLoginCounter: z.number(),
  lastFailedLogin: z.string(),
  defaultCallendarColor: z.string(),
  resetLinkExpires: z.string(),
  activeCurrency: z.string(),
  systemTheme: z.string(),
  isExternalLogin: z.boolean(),
  importCode: z.string(),
  modificationDate: z.string(),
  msexchange: z.string(),
  uri: z.string(),
  fullName: z.string(),
  isDeleted: z.boolean(),
});

export const PartialAccountUserFieldsSchema =
  AccountUserFieldsSchema.deepPartial();

export const AccountUserExtraFieldsSchema = z.object({
  attributes: z.array(z.any()),
  company: CompanySchema,
  place: PlaceSchema,
});

export const PartialAccountUserExtraFieldsSchema =
  AccountUserExtraFieldsSchema.deepPartial();

export const AccountUserSchema = z.intersection(
  AccountUserFieldsSchema,
  AccountUserExtraFieldsSchema
);

export type AccountUserFields = z.infer<typeof AccountUserFieldsSchema>;
export type PartialAccountUserFields = z.infer<
  typeof PartialAccountUserFieldsSchema
>;
export type AccountUserExtraFields = z.infer<
  typeof AccountUserExtraFieldsSchema
>;
export type PartialAccountUserExtraFields = z.infer<
  typeof PartialAccountUserExtraFieldsSchema
>;

export type AccountUser = z.infer<typeof AccountUserSchema>;
export type AccountUserPartial = z.infer<typeof PartialAccountUserFieldsSchema>;
